module.exports = __webpack_public_path__ + "static/5-f0c61b00e19f64159e15e6312f9f8bdf.jpeg";